export default <template>
  <@field.Control min={{@definition.min}} max={{@definition.max}} />
</template>
